import React from "react";
import { useTranslation } from "react-i18next";
import "./DoctorStatusBanner.css";

/**
 * Badge compact affiché À CÔTÉ du nom du médecin dans la navbar.
 *
 * - pending  → orange pastel, icône horloge
 * - approved → vert, icône check
 * - rejected → rouge, icône alerte + clic ouvre le popup de détails
 */
export default function DoctorStatusBanner({ status, onRejectedClick }) {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || "").startsWith("ar");

  const normalizedStatus = String(status || "").trim().toLowerCase();

  if (!normalizedStatus) return null;

  if (normalizedStatus === "approved") {
    return (
      <span
        className="doctor-status-badge doctor-status-badge--verified"
        dir={isRTL ? "rtl" : "ltr"}
        title={t("doctorStatus.verified", "Compte vérifié")}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 6L9 17l-5-5" />
        </svg>

        <span className="doctor-status-badge__text">
          {t("doctorStatus.verifiedShort", "Vérifié")}
        </span>
      </span>
    );
  }

  if (normalizedStatus === "pending") {
    return (
      <span
        className="doctor-status-badge doctor-status-badge--pending"
        dir={isRTL ? "rtl" : "ltr"}
        title={t(
          "doctorStatus.pending",
          "Votre compte est en attente de vérification par notre équipe."
        )}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>

        <span className="doctor-status-badge__text">
          {t("doctorStatus.pendingShort", "En attente")}
        </span>
      </span>
    );
  }

  if (normalizedStatus === "rejected") {
    return (
      <span
        role="button"
        tabIndex={0}
        className="doctor-status-badge doctor-status-badge--rejected"
        dir={isRTL ? "rtl" : "ltr"}
        title={t(
          "doctorStatus.rejected",
          "Votre compte a été rejeté. Cliquez pour voir les détails."
        )}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onRejectedClick?.();
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onRejectedClick?.();
          }
        }}
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" />
          <line x1="9" y1="9" x2="15" y2="15" />
        </svg>

        <span className="doctor-status-badge__text">
          {t("doctorStatus.rejectedShort", "Rejeté")}
        </span>
      </span>
    );
  }

  return null;
}